import { render, staticRenderFns } from "./UploadBukti.vue?vue&type=template&id=16e5a08d&lang=pug&"
import script from "./UploadBukti.vue?vue&type=script&lang=js&"
export * from "./UploadBukti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports